
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fixeds: false,
    pagination:null
  },
  mutations: {
    toFixed(state, val) {
      state.fixeds = val;
    },
    Pagination(state,val){
      state.pagination = val
      // console.log(state,val);
    }
  },
  actions: {

  },
});
